export default function Error(props) {
  if (props.display) {
    return (
      <div className="Error">
        Word Not Found in Dictionary <br /> Try another word
      </div>
    );
  } else {
    return null;
  }
}
